import styles from '../views/Cart/Sections/styles.module.scss'

export const AdjustableBaseErrorData = [
    {
        column1: [
            '2SVFCA7T',
            '2SVFCA6T'
        ],
        column2: [
            '8103-3XL-bundle',
            '8103-CK',
            '8103-6/6',
            '8103-5/0',
            '8103-3XL',
            '8109-6/6',
            '8109-3XL-split-bundle',
            '8109-3XL-bundle',
            '8109-CK',
            '8109-SQ',
            '8109-5/0',
            '8109-CK-bundle',
            '8109-4/6',
            '8109-CK-split-bundle',
            '8109-SQ-bundle',
            '8109-3XL',
            '8109-3/3'
        ],
        errorMessage: ` Please add the correct size <span class='${styles.itemMessageError}'>Saatva Adjustable Base Plus, Upper-Flex</span> if you plan to use with the <span class='${styles.itemMessageError}'>Solaire Upper-Flex</span> in your cart. 
     Contact us at 1-877-672-2882 for more assistance.`
    },
    {
        column1: [
            '8103-3XL-bundle',
            '8103-CK',
            '8103-6/6',
            '8103-5/0',
            '8103-3XL',
            '8109-6/6',
            '8109-3XL-split-bundle',
            '8109-3XL-bundle',
            '8109-CK',
            '8109-SQ',
            '8109-5/0',
            '8109-CK-bundle',
            '8105-6/6',
            '8105-5/0',
            '8109-4/6',
            '8109-CK-split-bundle',
            '8109-SQ-bundle',
            '8109-3XL',
            '8109-3/3'
        ],
        column2: [
            '7052-CK',
            '7053-CK',
            '7051-CK',
            '7052-4/6',
            '7053-4/6',
            '7051-4/6',
            '7052-6/6',
            '7053-6/6',
            '7051-6/6',
            '7052-5/0',
            '7053-5/0',
            '7051-5/0',
            '7052-3XL-bundle',
            '7053-3XL-bundle',
            '7051-3XL-bundle',
            '7052-3/3',
            '7053-3/3',
            '7051-3/3',
            '7052-3XL',
            '7053-3XL',
            '7051-3XL'
        ],
        errorMessage: `<span class='${styles.itemMessageError}'>Saatva Classic 14.5'</span> height is NOT compatible with adjustable bases. Please update your cart with the <span class='${styles.itemMessageError}'>Saatva Classic 11.5'</span> height option in order to use with an adjustable base, or contact us at 1-877-672-2882 for more assistance.`
    },
    {
        column1: [
            '8103-3XL-bundle',
            '8103-CK',
            '8103-6/6',
            '8103-5/0',
            '8103-3XL',
            '8109-6/6',
            '8109-3XL-split-bundle',
            '8109-3XL-bundle',
            '8109-CK',
            '8109-SQ',
            '8109-5/0',
            '8109-CK-bundle',
            '8105-6/6',
            '8105-5/0',
            '8109-4/6',
            '8109-CK-split-bundle',
            '8109-SQ-bundle',
            '8109-3XL',
            '8109-3/3'
        ],
        column2: [
            '523-CK900203',
            '523-CK900101',
            '523-CK900202',
            '523-KG900203',
            '523-KG900101',
            '523-KG900202',
            '523-QN900203',
            '523-QN900101',
            '523-QN900202'
        ],
        errorMessage: `<span class='${styles.itemMessageError}'>The Sydney Bed Frame</span> is NOT compatible with adjustable bases. Please choose a different bed frame style if you plan to use with an adjustable base or contact us at 1-877-672-2882 for more assistance.`
    },
    {
        column1: [
            '8103-3XL-bundle',
            '8103-CK',
            '8103-6/6',
            '8103-5/0',
            '8103-3XL',
            '8109-6/6',
            '8109-3XL-split-bundle',
            '8109-3XL-bundle',
            '8109-CK',
            '8109-SQ',
            '8109-5/0',
            '8109-CK-bundle',
            '8105-6/6',
            '8105-5/0',
            '8109-4/6',
            '8109-CK-split-bundle',
            '8109-SQ-bundle',
            '8109-3XL',
            '8109-3/3'
        ],
        column2: [
            '1020-CK900105',
            '1020-KG900105',
            '1020-QN900105',
            '1020-CK800101',
            '1020-CK800202',
            '1020-CK800203',
            '1020-KG800101',
            '1020-KG800202',
            '1020-KG800203',
            '1020-QN800101',
            '1020-QN800202',
            '1020-QN800203'
        ],
        errorMessage: `<span class='${styles.itemMessageError}'>The Halle Storage Platform</span> is NOT compatible with adjustable bases. Please choose a different bed frame style if you plan to use with an adjustable base or contact us at 1-877-672-2882 for more assistance.`
    },
    {
        column1: [
            '8103-3XL-bundle',
            '8103-CK',
            '8103-6/6',
            '8103-5/0',
            '8103-3XL',
            '8109-6/6',
            '8109-3XL-split-bundle',
            '8109-3XL-bundle',
            '8109-CK',
            '8109-SQ',
            '8109-5/0',
            '8109-CK-bundle',
            '8105-6/6',
            '8105-5/0',
            '8109-4/6',
            '8109-CK-split-bundle',
            '8109-SQ-bundle',
            '8109-3XL',
            '8109-3/3'
        ],
        column2: [
            '593-CK900105',
            '593-KG900105',
            '593-QN900105',
            '593-CK800101',
            '593-CK800202',
            '593-CK800203',
            '593-KG800101',
            '593-KG800202',
            '593-KG800203',
            '593-QN800101',
            '593-QN800202',
            '593-QN800203'
        ],
        errorMessage: `The <span class='${styles.itemMessageError}'>Halle Storage Bed</span> is NOT compatible with adjustable bases. Please choose a different bed frame style if you plan to use with an adjustable base or contact us at 1-877-672-2882 for more assistance.`
    },
    {
        column1: [
            '7055-6/6',
            '7056-6/6',
            '7056-CK',
            '7054-6/6',
            '7054-CK',
            '7055-CK',
            '7056-CK',
            '7061-6/6',
            '7061-CK',
            '7059-6/6',
            '7060-6/6',
            '7062-6/6',
            '7062-CK',
            '2SVFC6T',
            '2SVFC1T',
            '7063-6/6',
            '7063-CK'
        ],
        column2: [
            '8109-SQ-bundle',
            '8109-CK-split-bundle',
            '8109-SQ',
            '8109-3XL-split-bundle',
            '8103-3XL-bundle'
        ],
        errorMessage: `Split King adjustable bases (made up of 2 Twin XLs) are designed to pair with Split King mattresses. 
         Although they can be synced together to work in tandem just like a regular King adjustable base, if you plan to use the two sides of the adjustable base independently, please update your mattress size to a Split King.`
    },
    {
        column1: [
            '8103-3XL-bundle',
            '8103-CK',
            '8103-6/6',
            '8103-5/0',
            '8103-3XL',
            '8109-6/6',
            '8109-3XL-split-bundle',
            '8109-3XL-bundle',
            '8109-CK',
            '8109-SQ',
            '8109-5/0',
            '8109-CK-bundle',
            '8105-6/6',
            '8105-5/0',
            '8109-4/6',
            '8109-CK-split-bundle',
            '8109-SQ-bundle',
            '8109-3XL',
            '8109-3/3'
        ],
        column2: [
            '7057-CK',
            '7057-4/6',
            '7057-6/6',
            '7057-5/0',
            '7057-3XL-bundle',
            '7057-3/3',
            '7057-3XL'
        ],
        errorMessage: `<span class='${styles.itemMessageError}'>Saatva HD</span> is NOT compatible with adjustable bases. We strongly recommend pairing it with the <span class='${styles.itemMessageError}'>HD foundation</span>. Please update your cart or contact us at 1-844-993-1073 for more assistance.`
    }
]

export const NonMatchingAdjustableBaseErrors = [
    {
        column1: [
            '2SVFCA7T',
            '2SVFCA6T'
        ],
        column2: [
            '8105-6/6',
            '8105-5/0'
        ],
        errorMessage: `<span class='${styles.itemMessageError}'>Solaire Upper-Flex</span> functionality requires pairing with <span class='${styles.itemMessageError}'>Saatva Adjustable Base Plus, Upper-Flex</span>. Please add the adjustable base to your cart or contact us at 1-877-672-2882 for more assistance.`
    },

]
